import { AggRelayEnvironment, createRelayResource } from '@townsquare/relay-utils';
import { type ResourceContext } from '@townsquare/router';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

import AssignedSectionQuery, {
  type AssignedSectionQuery as AssignedSectionQueryType,
} from '../assigned/__generated__/AssignedSectionQuery.graphql';

export const assignedSectionResource = createRelayResource<AssignedSectionQueryType>({
  getQuery: (_, resourceContext) => {
    const context = resourceContext as ResourceContext;
    const accountId = context.user.accountId;
    const isAssignedFeedEnabled = isGateEnabled('townsquare_enable_assigned_feed');

    return {
      environment: AggRelayEnvironment,
      query: AssignedSectionQuery,
      variables: {
        userId: `ari:cloud:identity::user/${accountId}`,
        isEnabled: isAssignedFeedEnabled,
      },
    };
  },
});
